import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import { MenuItem } from 'material-ui';

const StyledMenuItem = styled(MenuItem)`
    text-transform: uppercase;
`;

const ActionCell = (props) => {
    const {
        disabled,
        onClick,
        primaryText,
    } = props;

    return <StyledMenuItem
        disabled={ disabled }
        primaryText={ primaryText }
        onTouchTap={ onClick }
        style={ {
            color: disabled ? theme.palette.gray : theme.palette.secondary,
        } }
    />;
};

ActionCell.defaultProps = {
    disabled: false,
};

ActionCell.propTypes = {
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    primaryText: PropTypes.string.isRequired,
};

export default ActionCell;



// WEBPACK FOOTER //
// ./src/components/list/Filters/layout/ActionCell.js